import React from 'react';
import PropTypes from 'prop-types';
import PieChart from 'react-minimal-pie-chart';
import { getChartColor } from '../shared/chartHelpers';

const DashboardPieChart = ({ percentage, summaryText, text, label }) => (
  <div className="dashboard-pie-chart-container">
    {label ? <div className="pie-chart-label">{label}</div> : null}
    <div className="dashboard-pie-chart">
      <div className="dashboard-pie-chart-content-container">
        <div className="dashboard-pie-chart-content">
          <div
            className="dashboard-pie-chart-total-percentage"
          >
            {percentage}%
          </div>
          <div className="dashboard-pie-chart-summary-text">
            {summaryText}
          </div>
          <div
            className="dashboard-pie-chart-text"
          >
            {text}
          </div>
        </div>
      </div>
      <PieChart
        data={[
          { value: percentage, key: 1, color: getChartColor(percentage) },
          { value: 100-percentage, key: 2, color: '#dee2e6' },
        ]}
        startAngle={-90}
        lineWidth={15}
        totalValue={100}
      />
    </div>
  </div>
);

DashboardPieChart.propTypes = {
  percentage: PropTypes.number,
  summaryText: PropTypes.node,
  text: PropTypes.string,
  label: PropTypes.node,
};

export default DashboardPieChart;
